var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-fire-7ZQYWAVE38 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M8.59375 35C8.59375 35 5.46875 30.2713 5.46875 23.125C5.46875 15.9787 8.80125 17.5569 7.34375 10.625C7.34375 10.625 11.3381 15.7019 11.0938 20.625C11.0938 20.625 11.1031 15.1987 17.3438 11.25C23.5844 7.30125 23.5938 5 23.5938 5C23.5938 5 27.8919 9.56438 29.2188 15.625C30.5456 21.6856 28.5938 25 28.5938 25C28.5938 25 32.7225 22.105 32.9688 18.75C32.9688 18.75 37.8025 29.4081 30.4688 35",
    stroke: "#1C2541",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M11.094 20.625C11.094 20.625 10.7821 22.4156 11.2502 25.625",
    stroke: "#1C2541",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M16.1981 35C16.1981 35 15.1562 33.4237 15.1562 31.0419C15.1562 28.6594 16.2669 29.1856 15.7812 26.875C15.7812 26.875 17.1125 28.5675 17.0312 30.2081C17.0312 30.2081 17.0344 28.3994 19.1144 27.0831C21.195 25.7669 21.1981 25 21.1981 25C21.1981 25 22.6306 26.5212 23.0731 28.5419C23.515 30.5619 22.8644 31.6669 22.8644 31.6669C22.8644 31.6669 24.2406 30.7019 24.3231 29.5831C24.3231 29.5831 25.9344 33.1362 23.4894 35",
    stroke: "#1C2541",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M13.1251 22.8125C12.9664 22.4225 12.5689 17.6406 17.5001 14.0625",
    stroke: "#1C2541",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M30 32.5C30 32.5 32.5319 30.7225 32.5 26.25",
    stroke: "#1C2541",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService8);
export default __webpack_public_path__ + "static/media/service8.cf2ad808f10d869c2eb6b4a8141645eb.svg";
export { ForwardRef as ReactComponent };